export const NAVBAR_HEIGHT = 70;
export const NAVBAR_ZINDEX = 920;

export const MOBILE_NAV_WIDTH = 270;

export const SIDEBAR_WIDTH = 310;
export const SIDEBAR_COLLAPSED_WIDTH = 28;
export const SIDEBAR_ZINDEX = 1000;

export const DROPDOWN_ZINDEX = 1200;

export const SIDEBAR_ID = 'sidebar-container';

export const CELL_HEIGHT = 3;

export const DASHBOARDS_CHART_HEIGHT = 330;
